import { ChangeEvent, forwardRef, useRef, useState } from "react";
import styled from "styled-components";
import { Optionbox } from "../../../../Component/Interface/Live";
import { fontStyles } from "../../../../Component/style/common_font";
import {
  CenterView,
  Icon,
  RowView2,
} from "../../../../Component/style/common_style";

const OptionBox_tags = ({
  optionNum,
  optionList,
  selectList,
  delet_tag,
  insert_tag,
  select_tag,
}: {
  optionNum: number;
  optionList: Optionbox[];
  selectList: string[];
  delet_tag: (type: number, tag_seq: number) => void;
  insert_tag: (num: number, name: string) => Promise<boolean>;
  select_tag: (num: number, name: string) => void;
}) => {
  const scrollRef = useRef<HTMLInputElement | null>(null);

  const [open, setOpen] = useState(false);
  const [option_name, setOption_name] = useState("");

  const setting_option_name = (e: ChangeEvent<HTMLInputElement>) =>
    setOption_name(e.target.value);

  const open_box = () => {
    if (scrollRef && scrollRef.current) {
      scrollRef.current.scrollTo({
        top: 0,
      });
    }
    setOpen(true);
  };
  const insert_option = async () => {
    if (option_name.trim() === "") {
      return alert("옵션명을 입력해주세요.");
    }
    try {
      const res = await insert_tag(optionNum, option_name);
      if (res) {
        setOpen(false);
        setOption_name("");

        if (scrollRef && scrollRef.current) {
          scrollRef.current.scrollTo({
            top: scrollRef.current.scrollHeight,
          });
        }
      }
    } catch (error) {
      console.error("옵션 추가 중 에러 발생2:", error);
    }
  };

  return (
    <div>
      <Header>
        <div className="idx">구분</div>
        <div className="name">옵션명</div>
        <span onClick={open_box}>옵션추가 +</span>
      </Header>

      <ScrollBox ref={scrollRef}>
        {open && (
          <Tag>
            <div className="idx"></div>
            <div className="name">
              <input
                placeholder="옵션명을 입력해주세요."
                value={option_name}
                onChange={setting_option_name}
              />
            </div>
            <div className="btn" onClick={insert_option}>
              추가
            </div>
          </Tag>
        )}

        {optionList.map((data, idx) => {
          return (
            <Tag
              key={idx}
              className={selectList.includes(data.option_name) ? "this" : ""}
            >
              <div
                style={{ width: "100%" }}
                onClick={() => select_tag(optionNum, data.option_name)}
              >
                <div className="idx">{idx + 1}</div>
                <div className="name">{data.option_name}</div>
              </div>
              <Icon
                src={require("../../../../Image/ic_x_white.png")}
                onClick={() => delet_tag(optionNum, data.seq)}
              />
            </Tag>
          );
        })}
      </ScrollBox>
    </div>
  );
};
export default OptionBox_tags;

const Header = styled(RowView2)`
  margin-top: 0.5rem;
  color: #757575;
  background-color: #f8f8f8;
  border: 1px solid;
  border-bottom: 0;
  border-radius: 8px 8px 0 0;
  border-color: #f0f0f0;
  div.idx {
    width: 2.5rem;
    padding: 10px 0;
    margin-right: 1rem;
    text-align: center;
    border-right: 1px solid #f0f0f0;
  }
  div.name {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span {
    padding: 5px 15px;
    margin-right: 0.5rem;
    ${fontStyles.medium}
    font-size: 12px;
    color: white;
    background-color: #2d2d2d;
    border-radius: 4px;
    cursor: pointer;
  }
`;
const ScrollBox = styled.div`
  height: 15rem;
  border: 1px solid #f0f0f0;
  overflow: auto;
  border-radius: 0 0 8px 8px;
  &::-webkit-scrollbar {
    width: 12px;
    background-color: #f8f8f8;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    cursor: pointer;
    &:hover {
      background: #bdbdbd;
    }
  }
`;
const Tag = styled(CenterView)`
  position: relative;
  white-space: nowrap;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
  height: 2rem;
  &.this {
    color: #eb003b;
    border: 1px solid #eb003b;
    background-color: #ffe9e8;
  }
  div {
    display: flex;
    align-items: center;
    height: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  div.idx {
    width: 2.5rem;
    margin-right: 1rem;
    justify-content: center;
    border-right: 1px solid #f0f0f0;
  }
  div.name {
    flex: 1;
    cursor: pointer;
  }
  img {
    width: 10px;
    padding: 3px;
    margin-right: 0.5rem;
    background-color: #8e8e8e;
    border-radius: 50px;
    cursor: pointer;
  }
  /* 옵션추가 */
  input {
    flex: 1;
    height: 60%;
    margin-right: 0.5rem;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    &:hover,
    &:focus {
      border: 1px solid #454545;
    }
  }
  div.btn {
    justify-content: center;
    width: 2.5rem;
    height: 80%;
    ${fontStyles.medium}
    font-size: 12px;
    color: white;
    background-color: #2d2d2d;
    border-radius: 4px;
  }
`;
